import { ImageWMS } from "ol/source";
import { Group, Image as ImageLayer } from "ol/layer";

const urlEstadistica = import.meta.env.VITE_GEOSERVER_URL;

//layers censo 2022

const layersPorGobiernoLocalPorPoblacion = [
  {
    title: "Población que no tiene Obra Social, Prepaga ni Plan Estatal",
    layer: "cobertura_salud_por_gobierno_local_censo_2022",
  },
  {
    title: "Densidad poblacional por municipio",
    layer: "densidad_poblacional_por_municipio_censo2022",
  },
  {
    title: "Poblacion en viviendas particulares por municipio",
    layer: "poblacion_viviendas_particulares_por_municipio_censo_2022",
  },
  {
    title: "Promedio de personas en viviendas particulares por municipio",
    layer: "promedio_personas_vivendas_por_municipio_censo_2022",
  },
  {
    title: "Variación Promedio Anual de Población 2010 - 2022",
    layer: "variacion_promedio_poblacion_anual_gob_locales_censo_2022",
  },
];
const layersPorGobiernoLocalPorHogar = [
  {
    title: "CALMAT IV",
    layer: "calmat_iv_por_gobierno_local_censo_2022",
  },
  {
    title: "Hogares con piso de tierra, ladrillo suelto u otro material",
    layer: "calidad_materiales_piso_por_gobierno_local_censo_2022",
  },
  {
    title: "Hogares sin celular a internet",
    layer: "celular_internet_hogar_por_gobierno_local_censo_2022",
  },
  {
    title: "Hogares Que No Poseen Acceso a Computadoras, Tablets",
    layer: "computadora_tablet_hogar_por_gobierno_local_censo_2022",
  },
  {
    title: "Hogares con desagüe de Inodoro a Pozo Ciego, Hoyo o Excavación",
    layer:
      "desague_inodoro_pozo_ciego_hoyo_excavacion_por_gobierno_local_censo_2022",
  },
  {
    title: "Hogares Con Combustible para Cocina Carbón, Leña u Otros",
    layer:
      "combustible_carbon_lena_otros_para_cocina_por_gobierno_local_censo_2022",
  },
  {
    title: "Hogares sin acceso a internet",
    layer: "sin_acceso_a_internet_hogares_por_gobierno_local_censo_2022",
  },

  {
    title: "NBI 1 - Vivienda Tipo Inconveniente",
    layer: "nbi1_por_gobierno_local_censo_2022",
  },
  {
    title: "NBI 2 - Condiciones Sanitarias",
    layer: "nbi2_por_gobierno_local_censo_2022",
  },
  {
    title: "NBI 3 - Hacinamiento",
    layer: "nbi3_por_gobierno_local_censo_2022",
  },
  {
    title: "NBI 4 - Escolaridad",
    layer: "nbi4_por_gobierno_local_censo_2022",
  },
  {
    title: "NBI 5 - Capacidad de Subsistencia",
    layer: "nbi5_por_gobierno_local_censo_2022",
  },
  {
    title: "NBI Total",
    layer: "nbi_total_por_gobierno_local_censo_2022",
  },
  {
    title: "Deficit Habitacional Simple",
    layer: "dhs_por_gobierno_local_censo_2022",
  },
  {
    title: "Deficit Habitacional Cuantitativo Compuesto",
    layer: "dhcc_por_gobierno_local_censo_2022",
  },
];
const layersPorGobiernoLocalPorVivienda = [
  {
    title: "Variación Promedio Anual de Viviendas 2010 - 2022",
    layer: "variacion_promedio_viviendas_anual_gob_locales_censo_2022",
  },
  {
    title: "Viviendas Particulares por municipio",
    layer: "viviendas_particulares_por_municipio_censo_2022",
  },
];

/*por radios censales */

const indicadoresPorRadiosCensales = [
  {
    title: "Población por radio 2022",
    layer: "poblacion_por_radio_censo_2022",
  },
];

/*image layers */

/*gobierno local por Poblacion */
const imageLayersPorGobiernoLocalPorPoblacion =
  layersPorGobiernoLocalPorPoblacion.map(
    ({ title, layer }) =>
      new ImageLayer({
        title,
        visible: false,
        source: new ImageWMS({
          url: `${urlEstadistica}/censo2022/wms`,
          params: { LAYERS: layer, grupo: "censo2022" },
          serverType: "geoserver",
          crossOrigin: "Anonymous",
        }),
      })
  );
/*gobierno local por hogar*/
const imageLayersPorGobiernoLocalPorHogar = layersPorGobiernoLocalPorHogar.map(
  ({ title, layer }) =>
    new ImageLayer({
      title,
      visible: false,
      source: new ImageWMS({
        url: `${urlEstadistica}/censo2022/wms`,
        params: { LAYERS: layer, grupo: "censo2022" },
        serverType: "geoserver",
        crossOrigin: "Anonymous",
      }),
    })
);

/*gobierno local por vivienda */
const imageLayersPorGobiernoLocalPorVivienda =
  layersPorGobiernoLocalPorVivienda.map(
    ({ title, layer }) =>
      new ImageLayer({
        title,
        visible: false,
        source: new ImageWMS({
          url: `${urlEstadistica}/censo2022/wms`,
          params: { LAYERS: layer, grupo: "censo2022" },
          serverType: "geoserver",
          crossOrigin: "Anonymous",
        }),
      })
  );
/* radios censales  */
const imageLayersIndicadoresPorRadiosCensales =
  indicadoresPorRadiosCensales.map(
    ({ title, layer }) =>
      new ImageLayer({
        title,
        visible: false,
        source: new ImageWMS({
          url: `${urlEstadistica}/censo2022/wms`,
          params: { LAYERS: layer, grupo: "censo2022" },
          serverType: "geoserver",
          crossOrigin: "Anonymous",
        }),
      })
  );

export const censo2022 = new Group({
  title: "Censo 2022",
  fold: "close",
  layers: [
    new Group({
      title: "Indicadores por Gobiernos Locales",
      fold: "close",
      // layers: imageLayersCensoDep2022,
      layers: [
        new Group({
          title: "Población",
          fold: "close",
          layers: imageLayersPorGobiernoLocalPorPoblacion,
        }),
        new Group({
          title: "Hogar",
          fold: "close",
          layers: imageLayersPorGobiernoLocalPorHogar,
        }),
        new Group({
          title: "Vivienda",
          fold: "close",
          layers: imageLayersPorGobiernoLocalPorVivienda,
        }),
      ],
    }),
    new Group({
      title: "Indicadores por Radios Censales",
      fold: "close",
      layers: imageLayersIndicadoresPorRadiosCensales,
    }),
  ],
});
